import React, { useState, useEffect } from "react";
import image from "../../assets/images/quiz_img.png";

// 🔁 Fonction pour mélanger les options
const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

const QuestionCard = ({
  questionData,
  currentIndex,
  handleAnswer,
  progress,
}) => {
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [isAnswered, setIsAnswered] = useState(false);
  const [shuffledOptions, setShuffledOptions] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  // ✅ Quand la question change, on mélange les options
  useEffect(() => {
    if (questionData?.options?.length) {
      const shuffled = shuffleArray(questionData.options);
      setShuffledOptions(shuffled);
    }
    setSelectedAnswer(null);
    setIsAnswered(false);
    setErrorMessage("");
  }, [questionData]);

  // ✅ Gérer la sélection (une seule réponse possible)
  const selectAnswer = (option) => {
    if (!isAnswered) {
      setSelectedAnswer(option.id);
      setErrorMessage("");
    }
  };

  // ✅ Style des réponses selon sélection + correction
  const getOptionStyle = (option) => {
    if (!isAnswered) {
      return selectedAnswer === option.id ? "bg-yellow-200" : "bg-white";
    }

    if (option.is_correct && selectedAnswer === option.id) {
      return "bg-green-600 text-white";
    }

    if (!option.is_correct && selectedAnswer === option.id) {
      return "bg-red-500 text-white";
    }

    if (option.is_correct) {
      return "bg-green-100";
    }

    return "bg-white";
  };

  const progressPercent = Math.round(
    ((currentIndex + 1) / progress.length) * 100
  );

  return (
    <div className="mx-auto mt-1 mb-2 pb-10 w-full max-w-6xl md:min-w-[800px] px-1">
      {/* ✅ Progress bar */}
      <div className="w-full bg-orange-100 h-2 rounded-full mb-2 overflow-hidden">
        <div
          className="h-full bg-orange-500 transition-all duration-500"
          style={{ width: `${progressPercent}%` }}
        ></div>
      </div>

      {/* ✅ Barre d’émotions */}
      <div className="flex justify-between gap-2 px-5 mb-4 bg-[#FF9800] py-1 rounded-full overflow-x-auto">
        {Array.isArray(progress) &&
          progress.map((status, index) => (
            <div
              key={index}
              className={`rounded-full w-6 h-6 flex items-center justify-center text-white text-sm ${
                status === "correct"
                  ? "bg-green-500"
                  : status === "wrong"
                  ? "bg-red-500"
                  : "bg-orange-400"
              }`}
            >
              {status === "correct" ? "😊" : status === "wrong" ? "😡" : "😐"}
            </div>
          ))}
      </div>

      {/* ✅ Contenu principal */}
      <div className="flex flex-col md:flex-row bg-white rounded-2xl shadow-lg overflow-hidden">
        {/* Partie gauche */}
        <div className="w-full md:w-1/2 bg-teal-700 text-white flex flex-col items-center justify-center p-6">
          <h2 className="text-2xl font-bold mb-4">
            QUESTION {currentIndex + 1}
          </h2>
          <img
            src={image}
            alt="question"
            className="w-28 h-28 object-contain"
          />
        </div>

        {/* Partie droite */}
        <div className="w-full md:w-1/2 p-6 flex flex-col justify-center">
          <p className="text-lg font-bold text-yellow-600 mb-6">
            {questionData.html}
          </p>

          {/* ✅ Affichage des options mélangées */}
          {shuffledOptions.map((option, index) => {
            const optionKey = String.fromCharCode(65 + index); // A, B, C, D...
            return (
              <button
                key={option.id}
                onClick={() => selectAnswer(option)}
                disabled={isAnswered}
                className={`flex items-center justify-between px-4 py-2 mb-3 rounded-full border font-bold transition-all duration-300 hover:scale-105 ${getOptionStyle(
                  option
                )}`}
              >
                <span className="bg-white text-gray-800 rounded-full w-7 h-7 flex items-center justify-center mr-3 font-bold">
                  {optionKey}
                </span>
                <span className="flex-1 text-left">{option.html}</span>
              </button>
            );
          })}

          {/* ✅ Message d’erreur */}
          {errorMessage && (
            <p className="text-red-500 font-medium text-sm mt-2 mx-auto">
              {errorMessage}
            </p>
          )}

          {/* ✅ Bouton Valider */}
          {!isAnswered && (
            <button
              onClick={() => {
                if (selectedAnswer === null) {
                  setErrorMessage("Veuillez choisir une réponse !");
                  return;
                }

                setIsAnswered(true);

                const correctId = shuffledOptions.find(
                  (option) => option.is_correct
                )?.id;
                const isCorrect = selectedAnswer === correctId;

                const selectedOption = shuffledOptions.find(
                  (option) => option.id === selectedAnswer
                );

                handleAnswer(selectedOption, isCorrect);
              }}
              className="mt-4 bg-teal-600 text-white py-2 px-4 rounded hover:bg-teal-700"
            >
              Valider
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default QuestionCard;
